var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('IconBtn',{attrs:{"icon":"mdi-plus","title":"Add"},on:{"click":function($event){return _vm.create()}}}),_c('List',{staticClass:"my-5"}),_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }